export default class UpdateUserProfile {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  async execute(uid, userData) {
    // Préparer les données à mettre à jour
    const updateData = {
      updatedAt: new Date().toISOString()
    };

    // Gérer les champs spécifiques
    if (userData.displayName !== undefined) {
      updateData.displayName = userData.displayName;
    }

    if (userData.email !== undefined) {
      updateData.email = userData.email;
    }

    if (userData.phone !== undefined) {
      updateData.phone = userData.phone;
      updateData.phoneVerified = userData.phoneVerified || false;
    }

    if (userData.location !== undefined) {
      updateData.location = userData.location;
    }

    if (userData.bio !== undefined) {
      updateData.bio = userData.bio;
    }

    if (userData.interests !== undefined) {
      updateData.interests = userData.interests;
    }

    // Nettoyer les undefined et null
    const cleanedUserData = Object.entries(updateData).reduce((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});

    return this.userRepository.updateUser(uid, cleanedUserData);
  }
} 